
import { clearAllBodyScrollLocks, disableBodyScroll } from "body-scroll-lock";

const { site } = window.tg;


let simulateClick = function (elem) {
    // Create our event (with options)
    var evt = document.createEvent("MouseEvent");
    evt.initMouseEvent(
        'click',
         true, /* bubble */
         true, /* cancelable */
         window, null,
         0, 0, 0, 0, /* coordinates */
         false, false, false, false, /* modifier keys */
         0,/*left*/
        null
    );


    let canceled = !elem.dispatchEvent(evt);
};

/**
 *
 *  Mobile Menu mobile toggle
 *
 *  */
const mobileMenuEl = document.getElementById("menu-mobile");
const searchIconEl = document.querySelector(
    ".js-search-dropdown-toggle.search-summary-icon-search"
);
const mobileBackgroundEl = document.getElementById("js-menu-close");
const searchWrapperEl = document.getElementById("js-search-wrapper");
const menuToggle = document.querySelector('.js-menu-toggle')

/**
 *
 * Desktop Menu toggle
 *
 * */
const menuDesktopLink = document.querySelector(".menu-desktop-link");
const desktopMenuEl = document.getElementById("menu-desktop");
if (menuDesktopLink != null && site === 'ls') {
    let hideTimeout;

    menuDesktopLink.addEventListener("mouseenter", function (event) {
        clearTimeout(hideTimeout);
        desktopMenuEl.classList.add("push-right-front");
    })
    menuDesktopLink.addEventListener("mouseleave", function (event) {
        hideTimeout = setTimeout(function() {
            desktopMenuEl.classList.remove("push-right-front");
        }, 200);
    })

    desktopMenuEl.addEventListener("mouseenter", function (event) {
        clearTimeout(hideTimeout);
    })
    desktopMenuEl.addEventListener("mouseleave", function (event) {
        desktopMenuEl.classList.remove("push-right-front");
    })
}

// Feed function an id and it will tell you if it contains .show class
let isElementOpen = function (elem) {
    if(document.getElementById(elem) == undefined) {
        return false;
    }

    if (document.getElementById(elem).classList.contains('show')) {
        return true;
    } else {
        return false;
    }
}

// Remove/add show
let toggleOtherElement = function (elem) {
    let el = document.getElementById(elem)
    if (el.classList.contains('show')) {
        el.classList.remove('show')
    } else {
        el.classList.add('show')
    }
}

document.addEventListener("click", function (event) {
    // Make sure clicked element is our toggle

    const el = /** @type {HTMLElement} */ (event.target);

    if (!el.classList.contains("js-menu-toggle")) {
        return;
    }
    toggleMenu();
});

if (searchIconEl != null){
    searchIconEl.addEventListener(
        "click",
        function () {
            if (mobileMenuEl.classList.contains("show")){
                toggleMenu('close')
                clearAllBodyScrollLocks();
            }
        },
        false
    );
}

if (mobileMenuEl && mobileMenuEl !== undefined) {
    mobileMenuEl.addEventListener(
        "click",
        function (event) {
            const el = /** @type {HTMLElement} */ (event.target);

            if (!el.classList.contains("js-open-modal")) {
                return;
            }

            toggleMenu();
        },
        false
    );
}

if (mobileBackgroundEl && mobileBackgroundEl !== undefined) {
    mobileBackgroundEl.addEventListener(
        "click",
        function (event) {
            toggleMenu();
        },
        false
    );
}

function toggleMenu() {

    // checks to see if anything else is open
    if (isElementOpen("slideout-options")) {
        toggleOtherElement("slideout-options")
    }

    if (mobileMenuEl.classList.contains("show")) {
        mobileMenuEl.classList.remove("show");
        clearAllBodyScrollLocks();
        menuToggle.classList.remove('open')
        document.documentElement.style.height = "unset";
        Alpine.store('general').updateOpenSection('NONE');
    } else {

        if (searchWrapperEl !== null && searchWrapperEl !== undefined) {
            if (!searchWrapperEl.classList.contains("d-none")) {
                simulateClick(searchIconEl);
            }
        }

        clearAllBodyScrollLocks();
        mobileMenuEl.classList.add("show");
        document.documentElement.style.height = "100%";
        disableBodyScroll(mobileMenuEl);
        menuToggle.classList.add('open')
    }
}
